const componentTagMixin = (options: { default?: string } = {}) => {
  options.default = options.default || 'div'
  return {
    props: {
      tag: {
        type: String,
        default: options.default
      }
    },
  }
}
export default componentTagMixin